/**
 * САЙТЫН БИЧВЭРИЙН НЭГДСЭН ЖИШИГ.
 *
 * ! ЯАГААД НЭГ ГАЗАРТ: гарчиг бүр өөрийн гэсэн ангиллаар бичигдэж байсан —
 * ! `text-2xl sm:text-3xl lg:text-4xl`, `text-3xl font-bold`, `text-2xl
 * ! font-semibold` гэх мэт зургаан янз. Нэг хуудсан дээр зэрэгцэхэд хэмжээ
 * ! нь зөрж, аль нь илүү чухал болох нь уншигчид ойлгогдохоо больдог.
 *
 * ! ХАМГИЙН БАГА ХЭМЖЭЭ НЬ `text-xl` (20px). Өмнө нь тайлбар, тэмдэглэгээ
 * ! `text-sm` (14px) хүртэл жижгэрч байсныг захиалагч зөвшөөрөөгүй. Шинэ
 * ! бичвэр нэмэхдээ ЭНД байгаа тогтмолуудаас сонго; `text-sm`, `text-xs`
 * ! зэргийг агуулгын бичвэрт БҮҮ хэрэглэ (тоон тэмдэг, хөнгөлөлтийн
 * ! шошго зэрэг тогтмол өндөртэй чимэглэл нь үл хамаарна).
 */

/** Хэсгийн үндсэн гарчиг — «Агуулахын товч танилцуулга» түвшин */
export const SECTION_TITLE = 'text-3xl font-semibold tracking-tight text-balance md:text-4xl'

/** Картын гарчиг — хэсгийн дотор давтагдах нэгжүүд */
export const CARD_TITLE = 'text-2xl font-semibold tracking-tight text-balance'

/** Жижиг нэгжийн гарчиг — онцлохын мөр, зургийн тайлбарын толгой */
export const ITEM_TITLE = 'text-xl font-semibold tracking-tight'

/** Энгийн бичвэрийн ХАМГИЙН БАГА хэмжээ */
export const BODY_TEXT = 'text-xl'
